@if (filter$ | async; as filterNavigation) { @if (isSideBar) {
<ish-filter-navigation-sidebar [filterNavigation]="filterNavigation" (applyFilter)="applyFilter($event)" />
} @else {
<ish-filter-navigation-horizontal [filterNavigation]="filterNavigation" (applyFilter)="applyFilter($event)" />
<ish-filter-navigation-badges
  [filterNavigation]="filterNavigation"
  (applyFilter)="applyFilter($event)"
  (clearFilters)="clearFilters()"
/>
} }
